import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AnimatedLink from "@components/link/AnimatedLink";
import { MdOutlineOpenInNew } from "react-icons/md";
const FooterLinks = ({ links }) => {
    return (_jsx("div", { className: "footer__left-container", children: _jsx("ul", { className: "footer__menu", children: links.map((link, i) => (_jsxs("li", { className: "footer__menu-item", children: [_jsx(AnimatedLink, { label: link.title, url: link.url, openInNewTab: link.openInNewTab, color: "white", hoverColor: "white" }), link.openInNewTab && (_jsx("div", { className: "footer__menu-icon", children: _jsx(MdOutlineOpenInNew, {}) }))] }, i))) }) }));
};
export default FooterLinks;
